const downloadAppRedirect = {
    title: 'Uygulamayı indirmeye devam edin...',
    backBtn: 'Dizine geri dön',
};

export default downloadAppRedirect;
